module.exports = __webpack_public_path__ + "img/packages/h1.36af18.png";